import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { capabilities } from '@/mocks/smart-restaurant';

export default function Capabilities() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="五大解决方案能力"
          title="一套平台，覆盖餐厅经营与餐饮生态"
          subtitle="从门店经营到前后场协同、供应链、客户运营与平台治理，味聚将关键能力统一到可协同的数字化底座。"
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {capabilities.map((cap, idx) => (
            <Reveal key={cap.id} delay={idx * 60}>
              <div
                className={`group h-full p-6 rounded-lg border transition-all duration-300 hover:-translate-y-1 ${
                  cap.highlight
                    ? 'bg-accent-50 border-accent-300'
                    : 'bg-background-50 border-background-200 hover:border-accent-300'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${cap.icon} text-xl`}></i>
                  </div>
                  <span className="text-xs font-semibold text-foreground-400">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-base md:text-lg">
                  {cap.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{cap.desc}</p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {cap.keywords.map((kw) => (
                    <span
                      key={kw}
                      className={`px-2.5 py-1 rounded-full text-xs whitespace-nowrap ${
                        cap.highlight
                          ? 'bg-accent-500/15 text-accent-800'
                          : 'bg-secondary-100 text-secondary-900'
                      }`}
                    >
                      {kw}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}